import { PureComponent } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const StyledNavLink = styled(NavLink).attrs({ activeClassName: 'active' })`
  transition: all 200ms;
  display: flex;
  align-items: center;
  height: 50px;
  text-decoration: none;
  color: ${(props) => props.theme.mediumGray};
  fill: ${(props) => props.theme.mediumGray};

  &.active,
  &:hover {
    color: ${(props) => props.theme.primaryLighterColor};
    fill: ${(props) => props.theme.primaryLighterColor};
  }
`;

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
`;

const Count = styled.div`
  background: ${(props) => props.theme.darkGray};
  font-size: 10px;
  font-weight: bold;
  color: #fff;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

type Props = {
  icon: ReactNode;
  title: string | ReactNode;
  route: string;
  count?: number;
};

class SidebarItem extends PureComponent<Props> {
  render() {
    const { icon, title, route, count, ...props } = this.props;

    return (
      <StyledNavLink to={route} {...props}>
        <Icon>{icon}</Icon>
        {title}
        {!!count && <Count>{count}</Count>}
      </StyledNavLink>
    );
  }
}

export default SidebarItem;
